import SwiperCore, { Navigation, Pagination, A11y, Controller } from 'swiper'
import 'swiper/css/bundle'

SwiperCore.use([Navigation, Controller, Pagination, A11y])

export * from 'swiper/react'
